import React from 'react';
import { NavLink } from 'react-router-dom';
import layoutStyles from '../../styles/sidebarLayout.module.scss';
import { OrganisationalObjectives } from '../../components/habitsDashboard/OrganisationalObjectives/OrganisationalObjectives';

const SummaryPage = () => {
  return (
    <div className={layoutStyles.page}>
      <div className={layoutStyles.pageContainer}>
        {/* Sidebar with vertical tabs */}
        <aside className={layoutStyles.sidebar}>
          <nav className={layoutStyles.sidebarNav}>
            <NavLink
              to="/summary"
              end
              className={({ isActive }) =>
                `${layoutStyles.sidebarTab} ${isActive ? layoutStyles.active : ''}`
              }
            >
              Objectives
            </NavLink>
            <NavLink
              to="/initiative-summary"
              className={({ isActive }) =>
                `${layoutStyles.sidebarTab} ${isActive ? layoutStyles.active : ''}`
              }
            >
              Initiative summary
            </NavLink>
          </nav>
        </aside>

        {/* Main content */}
        <main className={layoutStyles.mainContent}>
          <div className={layoutStyles.tabContent}>
            <OrganisationalObjectives />
          </div>
        </main>
      </div>
    </div>
  );
};

export default SummaryPage;
